// chat-story 动画：已揭示消息数。
import type { SceneData } from '../../api/types'
import type { ChatData } from './types'

export function chatReveal(
  d: SceneData,
  time: number,
): { revealCount: number; typingMsg: number } {
  const data = d as unknown as ChatData
  const interval = 2.5
  const total = data.messages?.length ?? 0
  const targetCount = Math.min(Math.floor(time / interval) + 1, total)
  return { revealCount: targetCount, typingMsg: -1 }
}
